/** Fine print below the transcript composer. */
export const DISCLAIMER_TEXT = "help.com can make mistakes. Verify important information.";

/** Pre-upgrade single-thread key. Read once by the store's migration, then removed. */
export const LEGACY_MESSAGES_KEY = "help-chat-messages";

/** Holds the ConversationIndex — the sole record of which conversations exist. */
export const CONVERSATION_INDEX_KEY = "help-conversation-index";

/**
 * One envelope per conversation, keyed `help-conversation-<id>`. Every id is `con_…`, so an
 * envelope key can never collide with the index key.
 */
export const CONVERSATION_KEY_PREFIX = "help-conversation-";

/** Title cap, mirroring the backend's TruncateTitle (MessageController.cs). */
export const TITLE_MAX_LENGTH = 100;

/** The conversation route pattern — shared by routes.tsx and the layout's useMatch(). */
export const CONVERSATION_ROUTE = "/c/:conversationId";

/** The Privacy Policy page; nothing links to it until legal sign-off. */
export const PRIVACY_ROUTE = "/privacy";

/** The Terms of Use page; nothing links to it until legal sign-off. */
export const TERMS_ROUTE = "/terms";

/** Shown on both legal pages until legal sign-off removes it with the noindex tag. */
export const LEGAL_DRAFT_NOTICE = "Draft — pending legal review. This document is not yet in effect.";
